import{defineMessages}from'react-intl';

export default defineMessages({
loading_message:{
id:'i18n.loading_spinner.loading_message',
defaultMessage:'Loading...'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0xvYWRpbmdTcGlubmVyL0xvYWRpbmdTcGlubmVyLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwibG9hZGluZ19tZXNzYWdlIiwiaWQiLCJkZWZhdWx0TWVzc2FnZSJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsZ0JBQWlCO0FBQ2ZDLEdBQUksc0NBRFc7QUFFZkMsZUFBZ0IsWUFGRCxDQURXLENBQWYsQ0FBZiIsImZpbGUiOiJMb2FkaW5nU3Bpbm5lci5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBsb2FkaW5nX21lc3NhZ2U6IHtcbiAgICBpZDogJ2kxOG4ubG9hZGluZ19zcGlubmVyLmxvYWRpbmdfbWVzc2FnZScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdMb2FkaW5nLi4uJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/LoadingSpinner.messages.js
// module id = 2294
// module chunks = 0